export const MAIN = '.page--category-level2__cms-block';
export const MAINALTERNATIVE = 'dy_Global_Ribbon';
export const SLIDER = 'swiper-container';
export const BUYBUTTON = 'qvh24-buy-button';
export const NOTSELLABLE = 'qvh24--notSellable';
export const MAINMOBILE = '#main';
export const MAINMOBILE2 = 'page--category acte-page-category-mobile';
export const SWIPERUP = 'qvh24--swiper-up';
export const SWIPERDOWM = 'qvh24--swiper-down';
export const NOTIFICATION = 'qvh24--notification';
export const DATA = 'quick-view-all-data';
export const SELECTEDSKUATTRIBUTE = 'data-selected-child-sku';



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/components/quickview/constants/selectors.js
 **/